import { Button, Form, Modal } from "reactstrap";
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from "constants/index";
import React, { useState } from "react";

import CustomButton from "../../Button";
import PropTypes from "prop-types";
import TextInput from "../../TextInput";
import { toast } from "react-toastify";
import { validatePass } from "utils/validator";

const ResetPassword = ({ open, onClose, onConfirm }) => {
  const [pass, setPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [fromError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);

  const formValidator = () => {
    if (pass && confirmPass) {
      if (validatePass(pass)) {
        if (pass === confirmPass) {
          return true;
        } else {
          toast.error("Password and Confirm Password does not match!");
          setFormError("Password and Confirm Password does not match!");
        }
      } else {
        let errMsg = `Password must be minimum ${PASSWORD_MIN_LENGTH} characters and maximum ${PASSWORD_MAX_LENGTH} characters`;
        toast.error(errMsg);
        setFormError(errMsg);
      }
    } else {
      let err = `${!pass ? "Password" : "Confirm Password"} is required.`;
      toast.error(err);
      setFormError(err);
    }
  };

  const handleReset = async () => {
    setLoading(true);
    if (formValidator()) {
      await onConfirm(pass);
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <Modal zIndex={2000} centered isOpen={open} toggle={onClose}>
      <h3 style={{ textAlign: "center", marginTop: "10px" }}>Reset Password</h3>
      {fromError && (
        <p className="text-center" style={{ color: "#f24822" }}>
          {fromError}
        </p>
      )}
      <Form style={{ padding: "20px 30px" }}>
        <TextInput
          label="Password*"
          type="password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
        />
        <TextInput
          value={confirmPass}
          type="password"
          label="Confirm Password*"
          onChange={(e) => setConfirmPass(e.target.value)}
        />
        <div className="d-flex justify-content-between">
          <Button color="link" className="btn-link-dark" onClick={onClose}>
            Close
          </Button>
          <CustomButton
            label="Reset"
            onClick={handleReset}
            disabled={loading}
          />
        </div>
      </Form>
    </Modal>
  );
};

export default ResetPassword;

ResetPassword.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};
